import React from 'react'
import AppHeader from './layout/AppHeader'
import Dock from './dock/Dock'
import { CanvasDrawer } from './canvas/CanvasDrawer'

interface LayoutProps {
  children: React.ReactNode
}

/**
 * Layout Component
 *
 * TASK-086: Refactored to use existing AppHeader component
 * TASK-713: Global dock (one copilot everywhere) replaces the floating GenAIChat.
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header - TASK-086: Using existing AppHeader component */}
      <AppHeader />

      {/* Main Content */}
      <main className="flex-1 bg-gray-50">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-auto">
        <div className="kielis-container">
          <div className="py-4 text-center text-sm text-gray-500">
            © 2024 Kielis AG - Swiss External Asset Manager Platform
          </div>
        </div>
      </footer>

      {/* TASK-713: the ONE dock — self-suppresses on /dashboard (InputDock is the
          dashboard placement) and on unmigrated embedded-copilot routes. */}
      <Dock />

      {/* TASK-582: off-dashboard canvas surface for open_view summons (renders nothing on /dashboard) */}
      <CanvasDrawer />
    </div>
  )
}

export default Layout
